import { render, staticRenderFns } from "./demandList.vue?vue&type=template&id=711dc5f4&scoped=true&"
import script from "./demandList.vue?vue&type=script&lang=js&"
export * from "./demandList.vue?vue&type=script&lang=js&"
import style0 from "./demandList.vue?vue&type=style&index=0&id=711dc5f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711dc5f4",
  null
  
)

export default component.exports